import SVG from 'react-inlinesvg';

interface PinIconProps {
  textColor: string | undefined;
}

export const PinIcon = ({ textColor }: PinIconProps) => {
  if (textColor == null) {
    return <SVG src="/assets/icon_pin.svg" />;
  }

  return (
    <svg viewBox="0 0 15 18">
      <g>
        <g>
          <path
            style={{ fill: textColor }}
            d="M7.5,10.3c-1.4,0-2.6-1.2-2.6-2.6C4.9,6.2,6.1,5,7.5,5s2.6,1.2,2.6,2.6C10.1,9.1,8.9,10.3,7.5,10.3 M14.7,5.7
   c-0.3-1.3-1-2.5-1.9-3.4s-2.1-1.6-3.4-2c-1.3-0.3-2.6-0.3-3.9,0c-1.3,0.3-2.4,1-3.4,2c-0.9,1-1.6,2.1-1.9,3.4
   c-0.3,1.3-0.3,2.7,0,4c0.3,1.3,1,2.5,1.9,3.4l4.5,4.6C6.9,17.9,7.2,18,7.5,18c0.3,0,0.6-0.1,0.8-0.3l4.5-4.6
   c0.9-0.9,1.6-2.1,1.9-3.4C15.1,8.3,15.1,7,14.7,5.7"
          />
        </g>
      </g>
    </svg>
  );
};
